import React, { Component } from 'react';
import propTypes from 'prop-types';
import Isotope from 'isotope-layout';
import DayPicker from 'react-day-picker';
import axios from 'axios';
import ApiConfig from '../../config'
import MapsAPI from '../../google'

import popout from '../../assets/icons/popout.png';
import backArrow from '../../assets/icons/black/arrow_back.png';
import loader from '../../assets/loader.gif';
import calendarImg from '../../assets/icons/black/calendar.png';

export default class OfferAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sps: {
        ip: [],
        rp: [],
        ar: [],
        other: [],
      },
      cardView: 'loading',
      key: (MapsAPI()),
      arView: 'hideAR',
      rpView: 'showRP',
      ipView: 'showIP',
      otherView: 'hideOther',
      emailBody: '',
      mainSelected: 'selected',
      englishSelected: '',
      partnerSelected: '',
      selectedSPs: [],
      showNext: '',
    }
  }

  reviewView = e => {
    let eId = e.id;

    if (document.getElementById(e.id).className.includes(' opened')) {
      document.getElementById(e.id).className = document.getElementById(e.id).className.replace(' opened', '');
    } else {
      document.getElementById(e.id).className += ' opened';
    }
    setTimeout(function(){
      var elem = document.querySelector('.ModuleList');
      var iso = new Isotope( elem, {itemSelector: '.ModuleCard'});
    }, 100);
  }

  toggleSP = e => {
    let allSelected = this.state.selectedSPs;
    let eId = e.id;
    if (allSelected.filter(e => e.id === eId)[0]) {
      allSelected = allSelected.filter(e => e.id !== eId);
      document.getElementById(e.id).className = document.getElementById(e.id).className.replace(' selected', '');
    } else {
      document.getElementById(e.id).className += ' selected';
      allSelected.push(e);
    }

    this.setState({
      selectedSPs: allSelected,
    })

    if (allSelected.length === 0) {
      this.setState({showNext: ''})
    } else {
      this.setState({showNext: 'showNext'})
    }
  }

  generateEmail = () => {
    let mailtoOptions = [];
    if (this.state.mainSelected === 'selected') {
      mailtoOptions.push(this.state.openedOffer.fields['Email']);
    }
    if (this.state.englishSelected === 'selected') {
      mailtoOptions.push(this.state.openedOffer.fields['English Contact Email']);
    }
    if (this.state.partnerSelected === 'selected') {
      mailtoOptions.push(this.state.openedOffer.fields['Partner Email']);
    }

    mailtoOptions = mailtoOptions + '';

    let finalMail = 'mailto:' + mailtoOptions + '?subject=Account%20Offer%20from%20Vanguard%20Cleaning%20Systems&body=' +  encodeURI(this.state.emailBody);
    console.log(finalMail);

    var fakeDownloadA = document.createElement('a');
    fakeDownloadA.setAttribute('href', finalMail);

    fakeDownloadA.style.display = 'none';
    document.body.appendChild(fakeDownloadA);
    fakeDownloadA.click();
    document.body.removeChild(fakeDownloadA);
  }

  toggleSelect = e => {
    if (e === 'main') {
      if (this.state.mainSelected === 'selected') {
        this.setState({mainSelected: ''})
      } else {
        this.setState({mainSelected: 'selected'})
      }
    }

    if (e === 'english') {
      if (this.state.englishSelected === 'selected') {
        this.setState({englishSelected: ''})
      } else {
        this.setState({englishSelected: 'selected'})
      }
    }

    if (e === 'partner') {
      if (this.state.partnerSelected === 'selected') {
        this.setState({partnerSelected: ''})
      } else {
        this.setState({partnerSelected: 'selected'})
      }
    }
  }

  toggleType = e => {
    if (e === 'ar') {
      if (this.state.arView === 'hideAR') {
        this.setState({arView: 'showAR'})
      } else if (this.state.arView === 'showAR') {
        this.setState({arView: 'hideAR'})
      }
    } else if (e === 'rp') {
      if (this.state.rpView === 'hideRP') {
        this.setState({rpView: 'showRP'})
      } else if (this.state.rpView === 'showRP') {
        this.setState({rpView: 'hideRP'})
      }
    } else if (e === 'ip') {
      if (this.state.ipView === 'hideIP') {
        this.setState({ipView: 'showIP'})
      } else if (this.state.ipView === 'showIP') {
        this.setState({ipView: 'hideIP'})
      }
    } else if (e === 'other') {
      if (this.state.otherView === 'hideOther') {
        this.setState({otherView: 'showOther'})
      } else if (this.state.otherView === 'showOther') {
        this.setState({otherView: 'hideOther'})
      }
    }

    setTimeout(function(){
      var elem = document.querySelector('.ModuleList');
      var iso = new Isotope( elem, {itemSelector: '.ModuleCard'});
    }, 100);
  }

  changeEmail = e => {
    this.setState({emailBody:e.target.value})

    setTimeout(function(){
      var elem = document.querySelector('.ModuleList');
      var iso = new Isotope( elem, {itemSelector: '.ModuleCard'});
    }, 100);
  }

  filterSPs = () => {
    let theSps = this.props.spList;
    let theSelected = [];

    if (this.props.currentRecord['Standing'] === 'Crew Change') {
      if (this.props.currentRecord['Rejected By']) {
        this.props.currentRecord['Rejected By'] = this.props.currentRecord['Rejected By'] + this.props.currentRecord['SP Number'] + ',';
      } else {
        this.props.currentRecord['Rejected By'] = this.props.currentRecord['SP Number'] + ',';
      }
    }

    let naAmount = parseFloat(this.props.currentRecord['Monthly Amount']);
    let naZip = this.props.currentRecord['Zip'].replace(/ /g, '').replace(/-/g, '');
    naZip = naZip.split('-')[0];

    let naAddress = this.props.currentRecord['Company Name'] + '+' + this.props.currentRecord['Address 1'];
    if (this.props.currentRecord['Address 2']) {naAddress = naAddress + this.props.currentRecord['Address 2'];}
    if (this.props.currentRecord['City']) {naAddress = naAddress + ', ' + this.props.currentRecord['City'] + ', Florida';} else {naAddress = naAddress + ', Florida';}
    naAddress = naAddress + ', ' + this.props.currentRecord['Zip'];

    console.log(naZip);
    let coveredSPs = [];
    let finalNonCovered = [];
    for (var i in theSps) {
      if (theSps[i].fields['Coverage Area']) {
        if (theSps[i].fields['Coverage Area'].includes(naZip)) {
          coveredSPs.push(theSps[i]);
        } else {
          finalNonCovered.push(theSps[i]);
        }
      } else {
        finalNonCovered.push(theSps[i]);
      }
    }



    // let fallbackSPs = [];
    // let finalNonCovered = [];
    // for (var i in nonCovered) {
    //   if (theSps[i].fields['Zip']) {
    //     if (theSps[i].fields['Zip'].includes(naZip)) {
    //       fallbackSPs.push(theSps[i]);
    //     } else {
    //       finalNonCovered.push(theSps[i]);
    //     }
    //   } else {
    //     finalNonCovered.push(theSps[i]);
    //   }
    // }


    // console.log('Fallback SPs');
    // console.log(fallbackSPs);

    // console.log('Other SPs');
    // console.log(finalNonCovered);

    let finalSPs = this.state.sps;

    for (var i in coveredSPs) {
      let thisIP;
      let thisRP;


      if (coveredSPs[i].fields['Owed']) { thisIP = parseFloat(coveredSPs[i].fields['Owed']);}
      if (coveredSPs[i].fields['RP Due']) { thisRP = parseFloat(coveredSPs[i].fields['RP Due']);}

      if (thisIP > 0) {
        finalSPs.ip.push(coveredSPs[i]);
      } else if (thisRP > 0) {
        finalSPs.rp.push(coveredSPs[i]);
      } else {
        finalSPs.ar.push(coveredSPs[i]);
      }

      if (this.props.currentRecord['Stored Offers']) {
        if (this.props.currentRecord['Stored Offers'].includes(coveredSPs[i].fields['Number'])) {
          let theStatus = this.props.currentRecord['Stored Offers'].split(coveredSPs[i].fields['Number'] + '(').pop().split('),')[0];
          if (theStatus === 'Accepted' || theStatus === 'Interested' || theStatus === 'Rejected' || theStatus === 'VM' || theStatus === 'Callback' || theStatus === 'Email') {
            coveredSPs[i].offerStatus = theStatus;
          }
          theSelected.push(coveredSPs[i]);
        }
      }
    }

    finalSPs.other = finalNonCovered;




// - [ ] Are set as “looking for more”
// - [ ] Total Revenue + New Account is less than their monthly total

    // for (var i in finalNonCovered) {
    //   // let isLooking;
    //   let naBracket = '';
    //
    //   if (finalNonCovered[i].fields['Account Capacity']) {
    //     if (naAmount > 1750) {
    //       naBracket = 'over';
    //     } else if (naAmount > 800) {
    //       naBracket = '1500';
    //     } else if (naAmount > 350) {
    //       naBracket = '750';
    //     } else {
    //       naBracket = '300';
    //     }
    //
    //     if (naBracket === finalNonCovered[i].fields['Account Capacity']) {
    //       finalSPs.other.push(finalNonCovered[i]);
    //     }
    //   }
    // }
    // put this down in the return if we bring it back!
    // <div className="row rowOther">
    //   <a className="btn softGrad--black" >Other Options</a>
    //   {this.state.sps.other.length > 500 ? this.state.sps.other.map((e) => this.spItem(e, 'other')) : ''}
    // </div>



    setTimeout((function() {
      this.setState({
        sps: finalSPs,
        cardView: 'list',
      })

      setTimeout((function() {
        if (this.props.currentRecord['Stored Offers']) {
          this.setState({
            cardView: 'return',
            selectedSPs: theSelected,
            showNext: 'showNext',
          })
        }

        if ((finalSPs.ip.length + finalSPs.rp.length) === 0) {
          this.toggleType('ar');
        }
      }).bind(this), 50);
    }).bind(this), 10);
  }

  offerNext = e => {
    if (e === 'over') {
      this.setState({
        cardView: 'list',
        showNext: ''
      })
    } else if (e === 'reload') {
      window.location.reload();
    } else {
      this.setState({
        cardView: e,
        showNext: ''
      })
    }

    setTimeout((function() {
      if (e === 'list') {
        for (var i in this.state.selectedSPs) {
          document.getElementById(this.state.selectedSPs[i].id).className += ' selected';
        }
        this.setState({
          showNext: 'showNext',
        })
      } else if (e === 'over') {
        this.setState({
          sps: {
            ip: [],
            rp: [],
            ar: [],
            other: [],
          },
          selectedSPs: [],
        })
        let theCurrent = this.props.currentRecord;
        theCurrent['Stored Offers'] = '';

        let pushRecord = theCurrent;
        let pushRecordId = this.props.recordId;

        let finalPush = {"fields": pushRecord};
        axios
        .patch('https://api.airtable.com/v0/' + this.props.baseId + '/Customers/' + pushRecordId, finalPush)
        .then(response => {
          // saveOfferAction();
          console.log("we're done!");

          setTimeout((function() {
            this.filterSPs();
          }).bind(this), 100);
        })
      } else {
        let theSelected = this.state.selectedSPs;


        let today  = new Date();
        let newJson = '{"company":"' + this.props.currentRecord['Company Name'] + '","category":"' + this.props.currentRecord['Category'] + '","sqft":"' + this.props.currentRecord['Actual Sq Footage'] + '","amount":"' + this.props.currentRecord['Monthly Amount'] + '","date":"' + (today.getMonth()+1) + '/' + today.getDate()  + '/' + today.getFullYear() + '"}';
        for (var i in this.state.sps.ip) {
          if (this.state.sps.ip[i].fields['Offer Option']) {
            if (!this.state.sps.ip[i].fields['Offer Option'].includes(newJson)) {
              this.state.sps.ip[i].fields['Offer Option'] = newJson + ',' + this.state.sps.ip[i].fields['Offer Option'];
            }
          } else {
            this.state.sps.ip[i].fields['Offer Option'] = newJson
          }
        }
        for (var i in this.state.sps.rp) {
          if (this.state.sps.rp[i].fields['Offer Option']) {
            if (!this.state.sps.rp[i].fields['Offer Option'].includes(newJson)) {
              this.state.sps.ip[i].fields['Offer Option'] = newJson + ',' + this.state.sps.ip[i].fields['Offer Option'];
            }
          } else {
            this.state.sps.rp[i].fields['Offer Option'] = newJson
          }
        }
        for (var i in this.state.sps.ar) {
          if (this.state.sps.ar[i].fields['Offer Option']) {
            if (!this.state.sps.ar[i].fields['Offer Option'].includes(newJson)) {
              this.state.sps.ar[i].fields['Offer Option'] = newJson + ',' + this.state.sps.ar[i].fields['Offer Option'];
            }
          } else {
            this.state.sps.ar[i].fields['Offer Option'] = newJson
          }
        }

        for (var i in theSelected) {
          if (theSelected[i].fields['Offer Selected']) {
            if (!theSelected[i].fields['Offer Selected'].includes(newJson)) {
              this.state.sps.ip[i].fields['Offer Option'] = newJson + ',' + this.state.sps.ip[i].fields['Offer Option'];
            }
          } else {
            theSelected[i].fields['Offer Selected'] = newJson
          }
        }
        this.setState({
          selectedSPs: theSelected,
        })
      }
    }).bind(this), 100);

    setTimeout(function(){
      var elem = document.querySelector('.ModuleList');
      var iso = new Isotope( elem, {itemSelector: '.ModuleCard'});
    }, 100);
  }

  offerAction = (e, t) => {
    let franchBase = '';
    if (this.props.baseId === 'appg64RCoa58veKKD') {
      franchBase = 'appBsaVxz2OicG5Zw'
    } else if (this.props.baseId === 'appBUKBn552B8SlbE') {
      franchBase = 'appLxxBrc9m3yNXdQ'
    }
    this.setState({
      cardView: 'loading',
    })

    //let's save the Options
    let totalSaved = 0;

    let saveOptionsIP = function() {
      let allSP = this.state.sps;
      let allSPIPLength = allSP.ip.length;

      if (allSPIPLength > 0) {
        for (var i in allSP.ip) {
          console.log('saving list');
          if (!allSP.ip[i].saved) {
            if (allSP.ip[i].fields['Offer Selected']) {allSP.ip[i].selected = true;}
            allSP.ip[i].saved = true;
            let pushRecord = allSP.ip[i].fields;
            if (pushRecord.id) {delete pushRecord.id;}
            let pushRecordId = allSP.ip[i].id;

            let finalPush = {"fields": pushRecord};
            axios
            .patch('https://api.airtable.com/v0/' + franchBase + '/Franchisees/' + pushRecordId, finalPush)
            .then(response => {
              totalSaved ++;
              console.log(totalSaved);

              if (allSPIPLength === totalSaved) {
                totalSaved = 0;
                this.setState({
                  sps: allSP,
                  showNext: 'showNext',
                })

                setTimeout((function() {
                  saveOptionsRP();
                }).bind(this), 50);
              }
            })
          } else {
            totalSaved ++;
            console.log(totalSaved);

            if (allSPIPLength === totalSaved) {
              totalSaved = 0;
              this.setState({
                sps: allSP,
                showNext: 'showNext',
              })

              setTimeout((function() {
                saveOptionsRP();
              }).bind(this), 50);
            }
          }
        }
      } else {
        this.setState({
          showNext: 'showNext',
        })

        setTimeout((function() {
          saveOptionsRP();
        }).bind(this), 50);
      }

    }.bind(this);

    let saveOptionsRP = function() {
      console.log('going to saveRP');

      let allSP = this.state.sps;
      let allSPRPLength = allSP.rp.length;

      if (allSPRPLength > 0) {
        for (var i in allSP.rp) {
          if (!allSP.rp[i].saved) {
            if (allSP.rp[i].fields['Offer Selected']) {allSP.rp[i].selected = true;}
            allSP.rp[i].saved = true;
            let pushRecord = allSP.rp[i].fields;
            if (pushRecord.id) {delete pushRecord.id;}
            let pushRecordId = allSP.rp[i].id;

            let finalPush = {"fields": pushRecord};
            axios
            .patch('https://api.airtable.com/v0/' + franchBase + '/Franchisees/' + pushRecordId, finalPush)
            .then(response => {
              totalSaved ++;
              console.log(totalSaved);

              if (allSPRPLength === totalSaved) {
                totalSaved = 0;
                this.setState({
                  sps: allSP,
                  showNext: 'showNext',
                })

                setTimeout((function() {
                  saveOptionsAR();
                }).bind(this), 50);
              }
            })
          } else {
            totalSaved ++;
            console.log(totalSaved);

            if (allSPRPLength === totalSaved) {
              totalSaved = 0;
              this.setState({
                sps: allSP,
                showNext: 'showNext',
              })

              setTimeout((function() {
                saveOptionsAR();
              }).bind(this), 50);
            }
          }
        }
      } else {
        this.setState({
          showNext: 'showNext',
        })

        setTimeout((function() {
          saveOptionsAR();
        }).bind(this), 50);
      }
    }.bind(this);

    let saveOptionsAR = function() {
      console.log('going to saveAR');

      let allSP = this.state.sps;
      let allSPARLength = allSP.ar.length;

      if (allSPARLength > 0) {
        for (var i in allSP.ar) {
          if (!allSP.ar[i].saved) {
            if (allSP.ar[i].fields['Offer Selected']) {allSP.ar[i].selected = true;}
            allSP.ar[i].saved = true;
            let pushRecord = allSP.ar[i].fields;
            if (pushRecord.id) {delete pushRecord.id;}
            let pushRecordId = allSP.ar[i].id;

            let finalPush = {"fields": pushRecord};
            axios
            .patch('https://api.airtable.com/v0/' + franchBase + '/Franchisees/' + pushRecordId, finalPush)
            .then(response => {
              totalSaved ++;
              console.log(totalSaved);

              if (allSPARLength === totalSaved) {
                totalSaved = 0;
                this.setState({
                  sps: allSP,
                })

                setTimeout((function() {
                  saveSelected();
                }).bind(this), 50);
              }
            })
          } else {
            totalSaved ++;
            console.log(totalSaved);

            if (allSPARLength === totalSaved) {
              totalSaved = 0;
              this.setState({
                sps: allSP,
              })

              setTimeout((function() {
                saveSelected();
              }).bind(this), 50);
            }
          }
        }
      } else {
        setTimeout((function() {
          saveSelected();
        }).bind(this), 50);
      }
    }.bind(this);


    //let's save the action that was clicked
    let saveSelected = function() {
      console.log('save selected');
      let theCurrent = this.props.currentRecord;
      let theSelected = this.state.selectedSPs;
      let theSelectedLength = theSelected.length;

      theCurrent['Stored Offers'] = '';
      for (var i in theSelected) {
        theCurrent['Stored Offers'] += theSelected[i].fields['Number'] + ',';
        if (!theSelected[i].selected) {
          theSelected.selected = true;

          let pushRecord = theSelected[i].fields;
          let pushRecordId = theSelected[i].id;

          let finalPush = {"fields": pushRecord};
          axios
          .patch('https://api.airtable.com/v0/' + franchBase + '/Franchisees/' + pushRecordId, finalPush)
          .then(response => {
            totalSaved ++;
            console.log(totalSaved);

            if (theSelectedLength === totalSaved) {
              totalSaved = 0;
              this.setState({
                selected: theSelected,
              })

              setTimeout((function() {
                saveOfferAction();
              }).bind(this), 50);
            }
          })
        } else {
          totalSaved ++;
          console.log(totalSaved);

          if (theSelectedLength === totalSaved) {
            totalSaved = 0;
            this.setState({
              selected: theSelected,
            })

            setTimeout((function() {
              saveOfferAction();
            }).bind(this), 50);
          }
        }
      }
    }.bind(this);


    let saveOfferAction = function() {
      console.log('save action');
      let pushRecord = e.fields;
      if (pushRecord.id) {delete pushRecord.id;}

      let theCurrent = this.props.currentRecord;
      let pushRecordId = e.id;

      let today  = new Date();
      let newJson = '{"action":"' + t + '","company":"' + this.props.currentRecord['Company Name'] + '","category":"' + this.props.currentRecord['Category'] + '","sqft":"' + this.props.currentRecord['Actual Sq Footage'] + '","amount":"' + this.props.currentRecord['Monthly Amount'] + '","date":"' + (today.getMonth()+1) + '/' + today.getDate()  + '/' + today.getFullYear() + '"}';

      if (e.fields['Offer Action']) {
        if (!e.fields['Offer Action'].includes(newJson)) {
          e.fields['Offer Action'] = newJson + ',' + e.fields['Offer Action'];
        }
      } else {
        e.fields['Offer Action'] = newJson;
      }

      if (t === 'Rejected') {
        theCurrent['Stored Offers'] = theCurrent['Stored Offers'].replace((e.fields['Number'] + ','), '');
        if (theCurrent['Rejected By']) {
          theCurrent['Rejected By'] = theCurrent['Rejected By'] + e.fields['Number'] + ',';
        } else {
          theCurrent['Rejected By'] = e.fields['Number'] + ',';
        }
      } else if (t === 'Accepted') {
        let ipOwed = 0;
        let rpOwed = 0;
        let chargeable = 0;
        if (pushRecord['Owed']) {
          if (parseInt(pushRecord['Owed']) > 0) {
            ipOwed = parseInt(pushRecord['Owed']);
          }
        }
        if (pushRecord['RP Due']) {
          if (parseInt(pushRecord['RP Due']) > 0) {
            rpOwed = parseInt(pushRecord['RP Due']);
          }
        }
        if (pushRecord['Chargeable']) {
          if (parseInt(pushRecord['Chargeable']) > 0) {
            chargeable = parseInt(pushRecord['Chargeable']);
          }
        }

        let naAmount = parseInt(theCurrent['Monthly Amount']);
        let propedAmount;

        if (ipOwed > 0) {
          propedAmount = ipOwed - naAmount;

          if (propedAmount < 0) { //dipped into rp or chargeable
            ipOwed = 0;
            if (rpOwed > 0) {
              propedAmount = rpOwed - propedAmount;
              if (propedAmount < 0) { //dipped into chargeable
                rpOwed = 0;
                chargeable += (propedAmount * -1);
              } else { //there's still rp left
                rpOwed = propedAmount;
              }
            }
          } else { //there's still ip left
            ipOwed = propedAmount;
          }
        } else if (rpOwed > 0) {
          propedAmount = rpOwed - naAmount;

          if (propedAmount < 0) { //dipped into chargeable
            rpOwed = 0;
            chargeable += (propedAmount * -1);
          } else { //there's still rp left
            rpOwed = propedAmount;
          }
        } else {
          chargeable += naAmount;
        }
        pushRecord['Owed'] = ipOwed + '';
        pushRecord['RP Due'] = rpOwed + '';
        pushRecord['Chargeable'] = chargeable + '';

        if (pushRecord['Coverage Area'] && !pushRecord['Coverage Area'].includes(theCurrent['Zip'])) {
          pushRecord['Coverage Area'] = pushRecord['Coverage Area'] + ',' + theCurrent['Zip'];
        } else {
          pushRecord['Coverage Area'] = theCurrent['Zip'];
        }


      } else if (t === 'Interested' || t === 'VM' || t === 'Callback' || t === 'Email') {
        theCurrent['Stored Offers'] = theCurrent['Stored Offers'].replace((e.fields['Number'] + ','), (e.fields['Number'] + '(' + t + '),'));
      }


      let finalPush = {"fields": pushRecord};
      axios
      .patch('https://api.airtable.com/v0/' + franchBase + '/Franchisees/' + pushRecordId, finalPush)
      .then(response => {
        setTimeout((function() {
          saveCustomerRecord();
        }).bind(this), 50);
      })
    }.bind(this);


    let saveCustomerRecord = function() {
      let pushRecord = this.props.currentRecord;


      let dayTime;
      let today = new Date();
      if (today.getHours() > 12) {
        if (today.getMinutes() < 10) {
          dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + (today.getHours() - 12) + ":0" + today.getMinutes() + " PM";
        } else {
          dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + (today.getHours() - 12) + ":" + today.getMinutes() + " PM";
        }
      } else {
        if (today.getMinutes() < 10) {
          dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + today.getHours() + ":0" + today.getMinutes() + " AM";
        } else {
          dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + " AM";
        }
      }


      let newNotes;
      if (t === 'Accepted' || t === 'Interested' || t === 'Rejected' || t === 'Callback') {
        newNotes = dayTime + ' - ' + localStorage.getItem('userInitials') + '\n' + 'Offered to ' + e.fields['SP Name'] + ' - ' + t + '\n\n';
      } else if (t === 'VM') {
        let newNotes = dayTime + ' - ' + localStorage.getItem('userInitials') + '\n' + 'Offered to ' + e.fields['SP Name'] + ' - Left VM.\n\n';
      } else if (t === 'Email') {
        let newNotes = dayTime + ' - ' + localStorage.getItem('userInitials') + '\n' + 'Offered to ' + e.fields['SP Name'] + ' - Sent Email Offer.\n\n';
      }

      pushRecord['Notes'] = newNotes + pushRecord['Notes'];

      if (t === 'Accepted') {
        if (pushRecord['Standing'] === 'Crew Change') {
          this.setState({
            cardView: 'crewPrompt',
            selectedSPs: [e],
            showNext: 'showNext'
          })
        } else {
          this.setState({
            cardView: 'prompt',
            selectedSPs: [e],
            showNext: 'showNext'
          })
        }
      } else if (t === 'Rejected') {
        let newSelected = this.state.selectedSPs;
        let rejectedID = e.id;
        newSelected = newSelected.filter(e => e.id !== rejectedID);

        this.setState({
          cardView: 'reject',
          rejectedSP: [e],
          selectedSPs: newSelected,
          showNext: 'showNext'
        })
      }

      let pushRecordId = this.props.recordId;

      let finalPush = {"fields": pushRecord};
      axios
      .patch('https://api.airtable.com/v0/' + this.props.baseId + '/Customers/' + pushRecordId, finalPush)
      .then(response => {
        // saveOfferAction();

        console.log("we're done!");
      })
    }.bind(this);




    if (this.state.sps.ip.length > 0) {
      saveOptionsIP();
    } else if (this.state.sps.rp.length > 0) {
      saveOptionsRP();
    } else if (this.state.sps.ar.length > 0) {
      saveOptionsAR();
    }


    //mark the record as "offer in progress" and on next load, only show those who were selected. Make a "Load all button"


  }

  spSelectChange = e => {
    let theChange = this.state.selectedSPs[0];
    if (e.target.id === 'perCapacitySelect') {
      theChange.fields['Account Capacity'] = e.target.value;
    } else if (e.target.id === 'monthlyCapacitySelect') {
      theChange.fields['Monthly Capacity'] = e.target.value;
    } else if (e.target.id === 'lookingSelect') {
      theChange.fields['Looking for More'] = e.target.value;
    }

    this.setState({
      selectedSPs: [theChange],
    })
  }

  offerRejection = e => {
    let today = new Date();
    let newJson = '{"company":"' + this.props.currentRecord['Company Name'] + '","category":"' + this.props.currentRecord['Category'] + '","sqft":"' + this.props.currentRecord['Actual Sq Footage'] + '","amount":"' + this.props.currentRecord['Monthly Amount'] + '","date":"' + (today.getMonth()+1) + '/' + today.getDate()  + '/' + today.getFullYear() + '","reason":"' + document.getElementById('rejectedReason').value + '"}';
    if (e.fields['Offer Action']) {
      let oldJson = '{"action":"Rejected","company":"' + this.props.currentRecord['Company Name'] + '","category":"' + this.props.currentRecord['Category'] + '","sqft":"' + this.props.currentRecord['Actual Sq Footage'] + '","amount":"' + this.props.currentRecord['Monthly Amount'] + '","date":"' + (today.getMonth()+1) + '/' + today.getDate()  + '/' + today.getFullYear() + '"}';
      e.fields['Offer Action'] = newJson + ',' + e.fields['Offer Action'].replace(oldJson, '');
    } else {
      e.fields['Offer Action'] = newJson;
    }
    this.setState({
      rejectedSP: [e],
    })
    console.log('saving offer final');
    //updating the customer to have a note about the rejection reason
    let pushRecord = this.props.currentRecord;

    let dayTime;
    if (today.getHours() > 12) {
      if (today.getMinutes() < 10) {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + (today.getHours() - 12) + ":0" + today.getMinutes() + " PM";
      } else {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + (today.getHours() - 12) + ":" + today.getMinutes() + " PM";
      }
    } else {
      if (today.getMinutes() < 10) {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + today.getHours() + ":0" + today.getMinutes() + " AM";
      } else {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + " AM";
      }
    }
    let newNotes = dayTime + ' - ' + localStorage.getItem('userInitials') + '\n' + 'Rejection Reason - ' + document.getElementById('rejectedReason').value + '.\n\n';
    pushRecord['Notes'] = newNotes + pushRecord['Notes'];

    let pushRecordId = this.props.recordId;
    let finalPush = {"fields": pushRecord};
    axios
    .patch('https://api.airtable.com/v0/' + this.props.baseId + '/Customers/' + pushRecordId, finalPush)
    .then(response => {
      //saving the prompt amount (already set in state)
      let franchBase = '';
      if (this.props.baseId === 'appg64RCoa58veKKD') {
        franchBase = 'appBsaVxz2OicG5Zw'
      } else if (this.props.baseId === 'appBUKBn552B8SlbE') {
        franchBase = 'appLxxBrc9m3yNXdQ'
      }
      let pushRecord = e.fields;
      if (pushRecord.id) {delete pushRecord.id;}
      let pushRecordId = e.id;

      let finalPush = {"fields": pushRecord};
      axios
      .patch('https://api.airtable.com/v0/' + franchBase + '/Franchisees/' + pushRecordId, finalPush)
      .then(response => {
        window.location.reload();
      })
    });
  }

  offerFinal = e => {
    console.log('saving offer final');
    //updating the customer to have a new standing and sp number set

    let pushRecord = this.props.currentRecord;
    pushRecord['Standing'] = 'New Customer';
    pushRecord['SP Number'] = e.fields['Number'];
    pushRecord['Stored Offers'] = '';
    pushRecord['Rejected By'] = '';

    let dayTime;
    let today = new Date();
    if (today.getHours() > 12) {
      if (today.getMinutes() < 10) {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + (today.getHours() - 12) + ":0" + today.getMinutes() + " PM";
      } else {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + (today.getHours() - 12) + ":" + today.getMinutes() + " PM";
      }
    } else {
      if (today.getMinutes() < 10) {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + today.getHours() + ":0" + today.getMinutes() + " AM";
      } else {
        dayTime = (today.getMonth()+1) + "/" + today.getDate()  + "/" + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + " AM";
      }
    }
    let newNotes = dayTime + ' - ' + localStorage.getItem('userInitials') + '\n' + 'Account Accepted by ' + e.fields['SP Name'] + '.\n\n';
    pushRecord['Notes'] = newNotes + pushRecord['Notes'];

    let pushRecordId = this.props.recordId;
    let finalPush = {"fields": pushRecord};
    axios
    .patch('https://api.airtable.com/v0/' + this.props.baseId + '/Customers/' + pushRecordId, finalPush)
    .then(response => {
      //saving the prompt amount (already set in state)
      let franchBase = '';
      if (this.props.baseId === 'appg64RCoa58veKKD') {
        franchBase = 'appBsaVxz2OicG5Zw'
      } else if (this.props.baseId === 'appBUKBn552B8SlbE') {
        franchBase = 'appLxxBrc9m3yNXdQ'
      }
      let pushRecord = e.fields;
      if (pushRecord.id) {delete pushRecord.id;}
      let pushRecordId = e.id;

      let finalPush = {"fields": pushRecord};
      axios
      .patch('https://api.airtable.com/v0/' + franchBase + '/Franchisees/' + pushRecordId, finalPush)
      .then(response => {
        // add a volume record to the SP
        let today  = new Date();
        today = (today.getMonth()+1) + '/' + today.getDate() + '/' + today.getFullYear();

        let totalAmount;
        if (this.props.currentRecord['CPOP Amount']) {
          totalAmount = parseInt(this.props.currentRecord['Monthly Amount']) - parseInt(this.props.currentRecord['CPOP Amount']);
        } else {
          totalAmount = parseInt(this.props.currentRecord['Monthly Amount']);
        }
        let pushRecord = {
          'Account Name': this.props.currentRecord['Company Name'],
          'Type': null,
          'Rep. %': null,
          'Amount': totalAmount,
          'RP Revenue': null,
          'Start Date': this.props.currentRecord['Start Date'],
          'Notice Date': null,
          'Stop Date': null,
          'Short SP Name': e.fields['SP Name'],
        };
        let finalPush = {"fields": pushRecord}

        axios
        .post('https://api.airtable.com/v0/' + franchBase + '/Accounts', finalPush)
          .then(response => {
            window.location.reload();
          })
      })
    })


  }

  componentDidMount() {
    console.log(this.props.recordId);

    let loadOfferOptions = function() {
      console.log('loadOfferOptions');
      if (this.props.spList.length > 0) {
        this.filterSPs();
      } else {
        setTimeout((function() {
          loadOfferOptions();
        }).bind(this), 100);
      }
    }.bind(this);

    setTimeout((function() {
      loadOfferOptions();
    }).bind(this), 100);


  }

  // Render
  // ----------------------------------------------------
  render() {
    if (this.state.cardView === 'loading') {
      return (
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing']}>
          <div className="container">
            <div className="inner">
              <div className="row">
                <h3>Loading Offer Options</h3>
              </div>
              <img src={loader} className="loadingOffer" alt="" />
            </div>
          </div>
        </div>
      )
    } else if (this.state.cardView === 'list') {
      return(
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing'] + ' ' + this.state.arView + ' ' + this.state.ipView + ' ' + this.state.rpView+ ' ' + this.state.otherView + ' ' + this.state.showNext}>
          <div className="container">
            <div className="inner">
              <div className="nextBtn">
                <a className="btn showBtn softGrad--black" onClick={()=>this.offerNext('review')}>Next Step ({this.state.selectedSPs.length} selected)</a>
              </div>
              <div className="row">
                <h3>Offer Options</h3>
                <p>Select who you plan to offer to</p>
              </div>

              <div className="row rowIP">
                {this.state.sps.ip.length > 0 ? <h4 className={"toggleH " + this.state.ipView} onClick={()=>this.toggleType('ip')}>IP Due <em>({this.state.sps.ip.length})</em></h4> : ''}
                {this.state.sps.ip.length > 0 ? this.state.sps.ip.map((e) => this.spItem(e, 'ip')) : ''}
              </div>

              <div className="row rowRP">
                {this.state.sps.rp.length > 0 ? <h4 className={"toggleH " + this.state.rpView} onClick={()=>this.toggleType('rp')}>RP Due <em>({this.state.sps.rp.length})</em></h4> : ''}
                {this.state.sps.rp.length > 0 ? this.state.sps.rp.map((e) => this.spItem(e, 'rp')) : ''}
              </div>

              <div className="row rowAR">
                {this.state.sps.ar.length > 0 ? <h4 className={"toggleH " + this.state.arView} onClick={()=>this.toggleType('ar')}>Nearby AR <em>({this.state.sps.ar.length})</em></h4> : ''}
                {this.state.sps.ar.length > 0 ? this.state.sps.ar.map((e) => this.spItem(e, 'ar')) : ''}
              </div>

              <div className="row rowAll">
                {this.state.sps.other.length > 0 ? <h4 className={"toggleH " + this.state.otherView} onClick={()=>this.toggleType('other')}>Others AR <em>({this.state.sps.other.length})</em></h4> : ''}
                {this.state.sps.other.length > 0 ? this.state.sps.other.map((e) => this.spItem(e, 'other')) : ''}
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.state.cardView === 'return') {
      return(
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing'] + ' ' + this.state.showNext}>
          <div className="container">
            <div className="inner">
              <div className="nextBtn">
                <a className="btn showBtn softGrad--black" onClick={()=>this.offerNext('over')}>Start Over</a>
              </div>
              <div className="row">
                <h3>Previously Selected Options</h3>
              </div>

              <div className="reviewList">
                {this.state.selectedSPs.length > 0 ? this.state.selectedSPs.map((e) => this.reviewItem(e)) : ''}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.cardView === 'reject') {
      return(
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing'] + ' ' + this.state.showNext}>
          <div className="container">
            <div className="inner">
              <div className="nextBtn">
                <a className="btn showBtn softGrad--black" onClick={()=>this.offerRejection(this.state.rejectedSP[0])}>Save Rejection</a>
              </div>
              <div className="row nexted">
                <h3><img src={backArrow} alt="back" className="backBtn" onClick={() => this.offerNext('reload')} />Offer Rejection</h3>
              </div>

              <div className="row OfferCard">
                <p>Please explain why you think they rejected. (if no idea, say "no reason given")</p>
                <div className="rowInner">
                  <div className="inputBlock inputBlock--full">
                    <textarea
                      className="NotesList"
                      id="rejectedReason"
                      rows='3' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.cardView === 'crewPrompt') {
      return(
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing'] + ' ' + this.state.showNext}>
          <div className="container">
            <div className="inner">
              <div className="nextBtn">
                <a className="btn showBtn softGrad--black" onClick={()=>this.offerFinal(this.state.selectedSPs[0])}>Complete Acceptance</a>
              </div>
              <div className="row nexted">
                <h3><img src={backArrow} alt="back" className="backBtn" onClick={() => this.offerNext('reload')} />Offer Acceptance</h3>
              </div>

              <div className="row OfferCard">
                  <h4>Set Crew Change Change Date</h4>
                  <div className="rowInner">

                    <div className="inputBlock inputBlock--third">
                      <div className="pickWrapper">
                        <DayPicker onDayClick={this.props.handleDayClick} />
                      </div>
                      <label>New SP Start Date</label>
                      <div className="inputWithTag" id="offerNewSP" onClick={this.props.toggleDayPicker}>
                        <div className="inputTag">
                          <img src={calendarImg} alt="" />
                        </div>
                        <input
                          type="text"
                          value={this.props.currentRecord['New SP Start']}
                          id="newSP"
                          onChange={this.props.changeRecordHandler}
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h4>Update Franchise Projections</h4>
                  <p>(this would add ${this.props.currentRecord['Monthly Amount']} to their revenue)</p>
                  <div className="rowInner">
                    <div className="inputBlock inputBlock--half">
                      <label>Account Total</label>
                      <div
                        className="selectBlock"
                        id="perCapacity"
                        >
                        <select id="perCapacitySelect" value={this.state.selectedSPs[0].fields['Account Capacity']} onChange={this.spSelectChange}>
                          <option></option>
                          <option value="300">Under $300</option>
                          <option value="750">$300-$750</option>
                          <option value="1500">$750-$1500</option>
                          <option value="over">$1500+</option>
                        </select>
                      </div>
                    </div>

                    <div className="inputBlock inputBlock--half">
                      <label>Monthly Total</label>
                      <div
                        className="selectBlock"
                        id="monthlyCapacity"
                        >
                        <select id="monthlyCapacitySelect" value={this.state.selectedSPs[0].fields['Monthly Capacity']} onChange={this.spSelectChange}>
                          <option></option>
                          <option value="500">Under $500</option>
                          <option value="1000">$500-$1000</option>
                          <option value="2000">$1000-$2000</option>
                          <option value="3000">$2000-$3000</option>
                          <option value="over">$3000+</option>
                        </select>
                      </div>
                    </div>


                    <div className="inputBlock inputBlock--full">
                      <label>Looking for More?</label>
                      <div
                        className="selectBlock"
                        id="looking"
                        >
                        <select id="lookingSelect" value={this.state.selectedSPs[0].fields['Looking for More']} onChange={this.spSelectChange}>
                          <option></option>
                          <option>No</option>
                          <option value="500">Up to $500</option>
                          <option value="1000">Up to $1,000</option>
                          <option value="2000">Up to $2,000</option>
                          <option value="More">Over $2,000</option>
                        </select>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.cardView === 'prompt') {
      return(
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing'] + ' ' + this.state.showNext}>
          <div className="container">
            <div className="inner">
              <div className="nextBtn">
                <a className="btn showBtn softGrad--black" onClick={()=>this.offerFinal(this.state.selectedSPs[0])}>Complete Acceptance</a>
              </div>
              <div className="row nexted">
                <h3><img src={backArrow} alt="back" className="backBtn" onClick={() => this.offerNext('reload')} />Offer Acceptance</h3>
              </div>

              <div className="row OfferCard">
                  <h4>Review Start Date</h4>
                  <div className="rowInner">

                    <div className="inputBlock inputBlock--third">
                      <div className="pickWrapper">
                        <DayPicker onDayClick={this.props.handleDayClick} />
                      </div>
                      <label>Start Date</label>
                      <div className="inputWithTag" id="offerStart" onClick={this.props.toggleDayPicker}>
                        <div className="inputTag">
                          <img src={calendarImg} alt="" />
                        </div>
                        <input
                          type="text"
                          value={this.props.currentRecord['Start Date']}
                          id="start"
                          onChange={this.props.changeRecordHandler}
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h4>Update Franchise Projections</h4>
                  <p>(this would add ${this.props.currentRecord['Monthly Amount']} to their revenue)</p>
                  <div className="rowInner">
                    <div className="inputBlock inputBlock--half">
                      <label>Account Total</label>
                      <div
                        className="selectBlock"
                        id="perCapacity"
                        >
                        <select id="perCapacitySelect" value={this.state.selectedSPs[0].fields['Account Capacity']} onChange={this.spSelectChange}>
                          <option></option>
                          <option value="300">Under $300</option>
                          <option value="750">$300-$750</option>
                          <option value="1500">$750-$1500</option>
                          <option value="over">$1500+</option>
                        </select>
                      </div>
                    </div>

                    <div className="inputBlock inputBlock--half">
                      <label>Monthly Total</label>
                      <div
                        className="selectBlock"
                        id="monthlyCapacity"
                        >
                        <select id="monthlyCapacitySelect" value={this.state.selectedSPs[0].fields['Monthly Capacity']} onChange={this.spSelectChange}>
                          <option></option>
                          <option value="500">Under $500</option>
                          <option value="1000">$500-$1000</option>
                          <option value="2000">$1000-$2000</option>
                          <option value="3000">$2000-$3000</option>
                          <option value="over">$3000+</option>
                        </select>
                      </div>
                    </div>


                    <div className="inputBlock inputBlock--full">
                      <label>Looking for More?</label>
                      <div
                        className="selectBlock"
                        id="looking"
                        >
                        <select id="lookingSelect" value={this.state.selectedSPs[0].fields['Looking for More']} onChange={this.spSelectChange}>
                          <option></option>
                          <option>No</option>
                          <option value="500">Up to $500</option>
                          <option value="1000">Up to $1,000</option>
                          <option value="2000">Up to $2,000</option>
                          <option value="More">Over $2,000</option>
                        </select>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.cardView === 'review') {
      return(
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing'] + ' ' + this.state.showNext}>
          <div className="container">
            <div className="inner">
              <div className="nextBtn">
                <a className="btn showBtn softGrad--black" onClick={()=>this.offerNext('review')}>Done for now</a>
              </div>
              <div className="row nexted">
                <h3><img src={backArrow} alt="back" className="backBtn" onClick={() => this.offerNext('list')} />Let's Offer it!</h3>
              </div>

              <div className="reviewList">
                {this.state.selectedSPs.length > 0 ? this.state.selectedSPs.map((e) => this.reviewItem(e)) : ''}
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.state.cardView === 'offer') {
      return(
        <div className={"ModuleCard OfferList " + this.props.currentRecord['Standing']}>
          <div className="container">
            <div className="inner">
              <div className="row">
                <span onClick={()=>this.offerIt('back')}><img src={backArrow} /> Back</span>
                <h4>{this.state.openedOffer.fields['SP Name']}</h4>
              </div>

              <div className="row offerRow">
                <div className="innerQuestion">
                  <p>Who will you send the offer to?</p>
                  <div className="options">
                    {this.PartnerEmail}
                    {this.EnglishEmail}
                  </div>
                </div>
              </div>

              <div className="row offerRow">
                <div className="innerQuestion">
                  <p>{"Reason for choosing " + this.state.openedOffer.fields['SP Name'].split(' ')[0] + '.'}</p>

                  <div className="reasoningArea">
                    <textarea id="reasoning" placeholder="Please explain your reasoning..." rows="5" />
                  </div>

                </div>
              </div>


              <div className="row">
                <a className="btn showBtn softGrad--black" onClick={this.generateEmail}>Generate Email</a>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

// https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=Washington,DC&destinations=New+York+City,NY&key=AIzaSyBHjFAoFrHNd0x-mYqRrI-ZkpT8boKLCTw
  reviewItem(sp) {
    console.log(sp);
    let returnStatus = '';
    if (this.state.cardView === 'return' && sp.offerStatus) {
      if (sp.offerStatus === 'Accepted') {returnStatus = 'Accepted';}
      else if (sp.offerStatus === 'Interested') {returnStatus = 'Interested';}
      else if (sp.offerStatus === 'Rejected') {returnStatus = 'Rejected';}
      else if (sp.offerStatus === 'VM') {returnStatus = 'Left VM';}
      else if (sp.offerStatus === 'Callback') {returnStatus = 'Callback';}
      else if (sp.offerStatus === 'Email') {returnStatus = 'Sent Email';}
    }

    return (
      <div className="row" id={sp.id}>
        <h4 className="toggleH" onClick={()=>this.reviewView(sp)}>{sp.fields['SP Name']} <em>{sp.offerStatus ? '(' + returnStatus + ')' : ''}</em></h4>
        <div className="reviewItem" id={sp.id}>
          {sp.fields['Home Phone'] ? <p><em>Home</em> {sp.fields['Home Phone']}</p> : ''}
          {sp.fields['Cellphone'] ? <p><em>Cell</em> {sp.fields['Cellphone']}</p> : ''}
          {sp.fields['Partner Phone'] ? <p><em>Partner</em> {sp.fields['Partner Phone']}</p> : ''}
          {sp.fields['English Contact Phone'] ? <p><em>English</em> {sp.fields['English Contact Phone']}</p> : ''}

          <hr />

          {sp.fields['Email'] ? <p><em>Email</em> <a href={'mailto:' + sp.fields['Email'] + '?subject=Account%20Offer%20from%20Vanguard%20Cleaning%20Systems&body=' +  encodeURI('Good afternoon ' + sp.fields['SP Name'].split(' ')[0] + ',\n\nWe have a new account in your coverage area that I think you are a great fit for.\n\nPlease let me know if you are interested or if you would like to pass.\nThis account offer is yours for the next 24 hours. If we don’t hear from you by then, we will need to move onto other options.\n\nIf you have any questions or would like to discuss the account, please give me a call here:\n\nThank you,')}>{sp.fields['Email']}</a></p> : ''}

          {sp.fields['Partner Email'] ? <p><em>Partner Email</em> <a href={'mailto:' + sp.fields['Partner Email'] + '?subject=Account%20Offer%20from%20Vanguard%20Cleaning%20Systems&body=' +  encodeURI('Good afternoon ' + sp.fields['SP Name'].split(' ')[0] + ',\n\nWe have a new account in your coverage area that I think you are a great fit for.\n\nPlease let me know if you are interested or if you would like to pass.\nThis account offer is yours for the next 24 hours. If we don’t hear from you by then, we will need to move onto other options.\n\nIf you have any questions or would like to discuss the account, please give me a call here:\n\nThank you,')}>{sp.fields['Partner Email']}</a></p> : ''}

          {sp.fields['English Contact Email'] ? <p><em>English</em> <a href={'mailto:' + sp.fields['English Contact Email'] + '?subject=Account%20Offer%20from%20Vanguard%20Cleaning%20Systems&body=' +  encodeURI('Good afternoon ' + sp.fields['SP Name'].split(' ')[0] + ',\n\nWe have a new account in your coverage area that I think you are a great fit for.\n\nPlease let me know if you are interested or if you would like to pass.\nThis account offer is yours for the next 24 hours. If we don’t hear from you by then, we will need to move onto other options.\n\nIf you have any questions or would like to discuss the account, please give me a call here:\n\nThank you,')}>{sp.fields['English Contact Email']}</a></p> : ''}


          <hr />
          <div className="quickBtns">
            <div className="quickBtn" onClick={()=>this.offerAction(sp, 'Accepted')}>Accepted</div>
            <div className="quickBtn" onClick={()=>this.offerAction(sp, 'Interested')}>Interested</div>
            <div className="quickBtn" onClick={()=>this.offerAction(sp, 'Rejected')}>Rejected</div>
            <div className="quickBtn" onClick={()=>this.offerAction(sp, 'VM')}>Left VM</div>
            <div className="quickBtn" onClick={()=>this.offerAction(sp, 'Callback')}>Callback</div>
            <div className="quickBtn" onClick={()=>this.offerAction(sp, 'Email')}>Sent Email Offer</div>
          </div>
        </div>
      </div>
    )
  }
  spItem(sp, type) {
    let rejectedClass = '';
    if (this.props.currentRecord['Rejected By']) {
      let theRejected = this.props.currentRecord['Rejected By'].split(',');
      if (theRejected.filter(e => e === sp.fields['Number'])[0]) {
        rejectedClass = 'isRejected'
      }
    }

    let theRegion = '';
    if (this.props.baseId === 'appg64RCoa58veKKD') {
      theRegion = 'tampa';
    } else if (this.props.baseId === 'appBUKBn552B8SlbE') {
      theRegion = 'orlando';
    }

    let theLink = '/' + theRegion + '/franchisees/' + sp.id;



    if (type === 'ip') {
      return(
        <div className={"spItem " + type + ' ' + rejectedClass} id={sp.id}>
          <p>{sp.fields['SP Name']}</p>
          <em>${sp.fields['Owed']} owed</em>
          <a className="popout" href={theLink} target="_blank"><img src={popout} className="popout" /></a>
          <div className="absLink" onClick={()=>this.toggleSP(sp)}></div>
        </div>
      )
    } else if (type === 'rp') {
      return(
        <div className={"spItem " + type + ' ' + rejectedClass} id={sp.id}>
          <p>{sp.fields['SP Name']}</p>
          <em>${sp.fields['RP Due']} owed</em>
          <a className="popout" href={theLink} target="_blank"><img src={popout} className="popout" /></a>
          <div className="absLink" onClick={()=>this.toggleSP(sp)}></div>
        </div>
      )
    } else {
      return(
        <div className={"spItem " + type + ' ' + rejectedClass} id={sp.id}>
          <p>{sp.fields['SP Name']}</p>
          <a className="popout" href={theLink} target="_blank"><img src={popout} className="popout" /></a>
          <div className="absLink" onClick={()=>this.toggleSP(sp)}></div>
        </div>
      )
    }
  }

  get EnglishEmail() {
    if (this.state.openedOffer['English Contact Email']) {
      <div className={"offerOption " + this.state.englishSelected} id="englishEmail" onClick={()=>this.toggleSelect('english')}>
        <p>English: {this.state.openedOffer.fields['English Contact Email']}</p>
      </div>
    }
  }
  get PartnerEmail() {
    if (this.state.openedOffer['Partner Email']) {
      <div className={"offerOption " + this.state.partnerSelected} id="partnerEmail" onClick={()=>this.toggleSelect('partner')}>
        <p>Partner: {this.state.openedOffer.fields['Partner Email']}</p>
      </div>
    }
  }
}


OfferAccount.propTypes ={
  currentId: propTypes.string.isRequired,
  currentTable: propTypes.string.isRequired,
  currentRecord: propTypes.object.isRequired,
  handleDayClick: propTypes.func.isRequired,
  toggleDayPicker: propTypes.func.isRequired,
  changeRecordHandler: propTypes.func.isRequired,
  spChangeHandler: propTypes.func.isRequired,
  baseId: propTypes.string.isRequired,
  currentSP: propTypes.object.isRequired,
  spList: propTypes.object.isRequired,
  handleDayClick: propTypes.func.isRequired,
  toggleDayPicker: propTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/CustomerService/Records/OfferAccount.js